import React from 'react';
import ArticleCard from '../ArticleCard';
import { useRouter } from 'next/router';
import { useTranslation } from 'next-i18next';

const MoreStories = ({ posts }) => {
  const router = useRouter();
  const { locale } = router;
  const { t } = useTranslation('blog');
  const articles = posts.map((edge) => {
    const { node } = edge;
    const cardProps = {
      slug: node.slug,
      author: node.author?.node,
      thumbnail: node.featuredImage?.node?.sourceUrl,
      date: node.date,
      title: node.title,
      category: node.categories.edges[0].node,
      locale,
    };
    return <ArticleCard key={`article-${node.slug}`} {...cardProps} />;
  });
  return (
    <div className="more-posts-section mb-8">
      <h4 className="text-xl font-medium mb-8">{t('relatedArticles')}</h4>
      <div className="flex justify-between flex-wrap">{articles}</div>
    </div>
  );
};

export default MoreStories;
